// Localization bridge for legacy jweather code.
//
// A host app (JWX) installs window.jwxTranslate(key, fallback) and
// window.jwxLocale — see JWX/src/i18n/index.js — which resolve keys against
// its vue-i18n catalogs and name the active locale. Pages without a host
// (WindAlert-Web, DataScope-Web) render the English fallbacks unchanged.
//
// UMD: attaches localize()/localeDateNames() onto the jweather namespace for
// the gulp bundles, and exports them for module consumers (the JWX build
// side-effect-imports this file so Vue-bundled charts localize even on pages
// without a legacy bundle).
(function (global, factory) {
    var api = factory();

    if (typeof module === 'object' && typeof module.exports === 'object') {
        module.exports = api;
    }

    if (global) {
        global.jweather = global.jweather || {};
        global.jweather.localize = api.localize;
        global.jweather.localeDateNames = api.localeDateNames;
    }
})(typeof window !== 'undefined' ? window : this, function () {
    // Read at call time, so script/bundle load order never matters.
    // `params` fills {name} placeholders — via vue-i18n when the host resolves
    // the key, or by simple substitution into the English fallback otherwise.
    function localize(key, fallback, params) {
        var result =
            typeof window !== 'undefined' && typeof window.jwxTranslate === 'function'
                ? window.jwxTranslate(key, fallback, params)
                : fallback;

        if (params) {
            result = result.replace(/\{(\w+)\}/g, function (match, name) {
                return name in params ? params[name] : match;
            });
        }

        return result;
    }

    // Locale-aware date name tables, built from Intl for window.jwxLocale and
    // cached per locale. English tables when no host locale is present.
    var EN_DATE_NAMES = {
        locale: null,
        days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        hour12: true,
    };
    var localeDateNamesCache = null;

    function localeDateNames() {
        var locale = typeof window !== 'undefined' ? window.jwxLocale : null;

        if (!locale) return EN_DATE_NAMES;
        if (localeDateNamesCache && localeDateNamesCache.locale === locale) return localeDateNamesCache;

        try {
            var part = function (options, dateUTC) {
                return new Intl.DateTimeFormat(locale, options).format(dateUTC);
            };
            var names = { locale: locale, days: [], daysShort: [], months: [], monthsShort: [] };

            for (var m = 0; m < 12; m++) {
                var monthDate = new Date(Date.UTC(2024, m, 1));
                names.months.push(part({ month: 'long', timeZone: 'UTC' }, monthDate));
                names.monthsShort.push(part({ month: 'short', timeZone: 'UTC' }, monthDate));
            }
            // 2024-01-07 was a Sunday; tables are Sunday-first.
            for (var d = 0; d < 7; d++) {
                var dayDate = new Date(Date.UTC(2024, 0, 7 + d));
                names.days.push(part({ weekday: 'long', timeZone: 'UTC' }, dayDate));
                names.daysShort.push(part({ weekday: 'short', timeZone: 'UTC' }, dayDate));
            }

            names.hour12 = new Intl.DateTimeFormat(locale, { hour: 'numeric' }).resolvedOptions().hour12 !== false;

            localeDateNamesCache = names;
        } catch (e) {
            localeDateNamesCache = Object.assign({}, EN_DATE_NAMES, { locale: locale });
        }

        return localeDateNamesCache;
    }

    return { localize: localize, localeDateNames: localeDateNames };
});
